<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="width: 90% !important;">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Detalle de la solicitud (Rechazada)
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3 mb-3">
                        <div class="marco_detalle_descuentos_aprobados">

                            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;text-align: center;">
                                            Código
                                        </th>
                                        <th style="width: 20%;">
                                            Nombre
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Cantidad
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Precio
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Subtotal
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Descuento
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Total c/descuento
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in datos" :key="index">
                                        <td style="text-align: center;">
                                            {{ item.codigo }}
                                        </td>
                                        <td>
                                            {{ item.nombre_articulo }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ Math.abs(item.cantidad) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.precio.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ (Math.abs(item.cantidad) * item.precio).toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.descuento.toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ ((Math.abs(item.cantidad) * item.precio) -
                                                item.descuento).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                                }) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    export default {
        name: 'RechazadasDetalle',
        props: ['item'],
        computed: {
            ...mapState(['id_empresa_seleccionada'])
        },
        data() {
            return {
                datos: []
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async repartidor() {
                let f = {
                    api: `movimientos-detalles/c/movimientos_por_id?idd=${this.item.id_documento}&empresa=${this.item.empresa}`
                }

                let r = await this.obtener_data(f)
                this.datos = r

                // for (let i = 0; i < r.length; i++) {
                //     const e = r[i];
                //     this.datos[i].precio_con_descuento = e.precio
                // }
            },
            ...mapActions(['obtener_data'])
        },
        mounted() {
            this.repartidor()
        },
    }
</script>

<style>
    .marco_detalle_descuentos_aprobados {
        width: 100%;
        height: 400px;
        overflow: auto;
    }
</style>